<template>
  <div class="container is-fluid section is-paddingless">
    <h4 class="subtitle is-4 has-text-centered">Looking for UI/UX/Frontend Developers</h4>

    <BrowserScaffold class="browser-scaffold-root" :address="origin">
      <template v-slot:body>
        <div class="is-flex is-align-items-center is-justify-content-center" style="height: 100%;">
          <i-mdi-play-circle width="80" height="80" class="body-icon"/>
        </div>
      </template>
    </BrowserScaffold>

    <p class="mt-6">
      We're looking for help in redesigning TwoSeven.
      If you have experience in
      <span class="is-italic">designing user interfaces</span>
      that enable <span class="is-italic">rich user experience</span> or
      in <span class="is-italic">creating beautiful websites using VueJS</span>, please reach out to us!
    </p>

    <p class="mt-4">
      If you're interested, send us a brief description of your vision for the redesign and examples of your previous work to <br>
      <a href="mailto:redesign@twoseven.xyz">redesign@twoseven.xyz</a>
    </p>

    <p class="mt-4">
      We look forward to hearing from you!
    </p>
  </div>
</template>

<script>
export default {
  components: {
    BrowserScaffold: () => import(/* webpackChunkName: "browser-scaffold" */ '@C/common/browser-scaffold.vue')
  },
  computed: {
    origin () {
      return window.location.origin
    }
  }
}
</script>

<style lang="scss" scoped>
.browser-scaffold-root {
  ::v-deep .browser-scaffold {
    --width: 400px;
    --height: 225px;

    --action-buttons-min-width: 100px;
    --more-min-width: 60px;

    font-size: 0.8em;

    border: 1px solid var(--shadow-color);
    border-radius: 4px;

    .dark & {
      --shadow-color: #888;

      .body-icon {
        color: inherit;
      }
    }

    #app.dark & {
      .address-bar .address-bar-input {
        color: #222 !important;
      }
    }

    .body-icon {
      color: #aeaeae;
    }
  }
}
</style>
